<template>
  <span class="checkbox-container">
    <input type="checkbox" @click="handleChange" :checked="checked" />
    <span class="checkmark"></span>
  </span>
</template>

<script>
export default {
  computed: {
    store() {
      return this.config?.store
    },
    storeId() {
      return this.config?.storeId
    },
    row() {
      return this.config?.row || {}
    },
    rowIndex() {
      return this.config?.rowIndex || 0
    },
    checked() {
      return this.config?.cb[this.row._id]
    }
  },
  props: {
    config: Object
  },
  methods: {
    handleChange(e) {
      this.store.commit(`rows.${this.rowIndex}.cb`, e.target.checked)
    }
  }
}
</script>
